// extracted by mini-css-extract-plugin
export default {"invalidDataError":"BlogType_invalidDataError__m5Roe"};